module.exports = __webpack_public_path__ + "images/start.png";


//////////////////
// WEBPACK FOOTER
// ./images/start.png
// module id = 1133
// module chunks = 1